import { Button } from '#/components/ui/button';
import { cn } from '#/lib/utils';

import { DATA_AREAS } from '~/constants/data-areas';

import type { GlobalConfigFooter, ServiceMenus } from '../api/global-config';
import { SvgImgIllustKabukatsu } from '../svg/img-illust-kabukatsu';
import { SiteFooterCarousel } from './site-footer-carousel';

export const SiteFooter = (props: { globalConfigFooter: GlobalConfigFooter; serviceMenus?: ServiceMenus }) => {
  const { globalConfigFooter, serviceMenus } = props;
  const items = globalConfigFooter.items || [];
  const copyright = globalConfigFooter.copyright;

  return (
    <>
      {serviceMenus && (
        <div className="peer/footer isolate overflow-hidden text-center">
          <div>
            <div className="text-caption-m text-grey-500 mx-auto max-w-screen-lg space-y-[2px] p-6 px-4 text-left lg:pt-20 lg:pb-[128px]">
              <div className="flex gap-3.5">
                <span>※1</span>
                <div>
                  カブアンドでの株の受け取りにはサービス利用と株式の申込が必要です。お申込前に当社ウェブサイト内の
                  <a
                    href={`${import.meta.env.VITE_APP_KABUAND_URL}/documents/prospectus.pdf`}
                    className="underline"
                    aria-label="目論見書">
                    目論見書
                  </a>
                  をご覧ください。
                </div>
              </div>
              <div className="flex gap-2">
                <span>※2</span>
                <div>
                  利用料金全額には付与されない場合があります。付与対象となる利用料の詳細と計算方法は
                  <a
                    href={`${import.meta.env.VITE_APP_KABUAND_URL}/documents/kabuhikikaeken-information.pdf`}
                    className="underline">
                    こちら
                  </a>
                  。
                </div>
              </div>
            </div>
            <div className="relative flex justify-center">
              <div className="z-10 flex w-screen flex-col items-center">
                <SvgImgIllustKabukatsu
                  aria-label="カブ活イラスト"
                  className="mb-[54px] w-[176px] flex-none lg:mb-[75px] lg:h-[229px] lg:w-[269px]"
                />
                <p className="text-body-s-bold mb-2 w-full text-white">株がもらえる、カブアンドのサービス</p>
                <p className="text-headline-xl lg:text-headline-4xl mb-8 text-white">他にもたくさん。</p>
                <SiteFooterCarousel serviceMenus={serviceMenus} aria-label="カブアンドのサービス" />
              </div>
              <div className="bg-brand absolute top-20 left-1/2 block size-[1279px] -translate-x-1/2 rounded-full md:size-[2179px] lg:top-32"></div>
            </div>
          </div>
        </div>
      )}

      <footer
        className={cn(serviceMenus ? 'bg-brand text-white' : 'bg-grey-50 text-grey-900', 'mt-auto decoration-white')}
        data-area={DATA_AREAS.SITE_FOOTER}>
        <div className="w-full py-10 transition-all">
          <div className="mx-auto flex max-w-screen-lg flex-col gap-4 px-4 lg:px-4">
            {items.length > 0 && (
              <ul className="flex flex-col flex-wrap gap-x-6 gap-y-2 md:flex-row">
                {items.map((item) => (
                  <li key={item.label}>
                    <Button
                      asChild
                      variant="link"
                      className="text-caption-m-bold outline-grey-400 h-auto gap-1 rounded-[2px] p-0 font-normal break-words whitespace-pre-wrap decoration-inherit underline-offset-4 outline-2 outline-offset-4 transition-colors hover:underline">
                      <a
                        href={
                          item.label === '運営会社' ? item.href : `${import.meta.env.VITE_APP_KABUAND_URL}${item.href}`
                        }
                        aria-label={item.label}>
                        {item.label}
                      </a>
                    </Button>
                  </li>
                ))}
              </ul>
            )}
            {copyright && <p className={`${!serviceMenus && 'text-grey-500/80'} text-caption-s`}>{copyright}</p>}
          </div>
        </div>
      </footer>
    </>
  );
};
